var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { margin: "10px" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("epson")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("epson-enabled") },
                    model: {
                      value: _vm.layout.Epson.Enabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.layout.Epson, "Enabled", $$v)
                      },
                      expression: "layout.Epson.Enabled",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "8" } },
                [
                  _c("w-input", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("epson-service-url"),
                      placeholder: "https://labels.winfakt.app",
                    },
                    model: {
                      value: _vm.layout.Epson.ServiceUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.layout.Epson, "ServiceUrl", $$v)
                      },
                      expression: "layout.Epson.ServiceUrl",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { staticClass: "load-col", attrs: { sm: "4" } },
                [
                  _c(
                    "w-button",
                    {
                      attrs: {
                        disabled: !_vm.layout.Epson.ServiceUrl || _vm.loading,
                      },
                      on: { click: _vm.loadTemplates },
                    },
                    [_vm._v(_vm._s(_vm.$ct("epson-load-templates")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "6" } },
                [
                  _c("w-select", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("epson-template"),
                      items: _vm.templateItems,
                    },
                    model: {
                      value: _vm.layout.Epson.Template,
                      callback: function ($$v) {
                        _vm.$set(_vm.layout.Epson, "Template", $$v)
                      },
                      expression: "layout.Epson.Template",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { sm: "3" } },
                [
                  _c("w-input", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("epson-host"),
                      placeholder: "192.168.0.184",
                    },
                    model: {
                      value: _vm.layout.Epson.Host,
                      callback: function ($$v) {
                        _vm.$set(_vm.layout.Epson, "Host", $$v)
                      },
                      expression: "layout.Epson.Host",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { sm: "3" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      decimals: 0,
                      fancy: "",
                      label: _vm.$ct("epson-port"),
                    },
                    model: {
                      value: _vm.layout.Epson.Port,
                      callback: function ($$v) {
                        _vm.$set(_vm.layout.Epson, "Port", $$v)
                      },
                      expression: "layout.Epson.Port",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "6" } },
                [
                  _c("w-select", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("epson-quality"),
                      items: _vm.qualityItems,
                    },
                    model: {
                      value: _vm.layout.Epson.Quality,
                      callback: function ($$v) {
                        _vm.$set(_vm.layout.Epson, "Quality", $$v)
                      },
                      expression: "layout.Epson.Quality",
                    },
                  }),
                ],
                1
              ),
              _vm.selectedTemplate
                ? _c(
                    "w-col",
                    { staticClass: "template-info", attrs: { sm: "6" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedTemplate.label.widthMm) +
                          " × " +
                          _vm._s(_vm.selectedTemplate.label.heightMm) +
                          " mm "
                      ),
                      _vm.selectedTemplate.description
                        ? _c("span", [
                            _vm._v(
                              " · " + _vm._s(_vm.selectedTemplate.description)
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.error
            ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
            : _vm._e(),
          _vm.selectedTemplate
            ? [
                _c("h3", [_vm._v(_vm._s(_vm.$ct("epson-fields")))]),
                _c("p", { staticClass: "help" }, [
                  _vm._v(_vm._s(_vm.$ct("epson-fields-help"))),
                ]),
                _vm.defaultMapping
                  ? _c(
                      "w-row",
                      [
                        _c(
                          "w-col",
                          { staticClass: "defaults-col", attrs: { sm: "12" } },
                          [
                            _c(
                              "w-button",
                              {
                                attrs: { sm: "" },
                                on: { click: _vm.fillDefaults },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$ct("epson-fill-defaults", {
                                      model: _vm.modelName,
                                    })
                                  )
                                ),
                              ]
                            ),
                            _vm.defaultsMessage
                              ? _c("span", { staticClass: "help" }, [
                                  _vm._v(_vm._s(_vm.defaultsMessage)),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._l(_vm.selectedTemplate.fields, function (field) {
                  return [
                    field.kind != "rows"
                      ? _c(
                          "w-row",
                          { key: field.key },
                          [
                            _c(
                              "w-col",
                              { attrs: { sm: "12" } },
                              [
                                _c("w-input", {
                                  attrs: {
                                    value: _vm.getField(field.key),
                                    fancy: "",
                                    label: field.label,
                                    placeholder: _vm.placeholderFor(field),
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.setField(field.key, $event)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { key: field.key, staticClass: "rows-block" },
                          [
                            _c("div", { staticClass: "rows-title" }, [
                              _vm._v(_vm._s(field.label)),
                            ]),
                            _vm._l(field.rows, function (r) {
                              return _c(
                                "w-row",
                                { key: `${field.key}-${r}` },
                                _vm._l(field.columns, function (col) {
                                  return _c(
                                    "w-col",
                                    {
                                      key: `${field.key}-${r}-${col.key}`,
                                      attrs: { sm: 12 / field.columns.length },
                                    },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          value: _vm.getField(
                                            `${field.key}.${r - 1}.${col.key}`
                                          ),
                                          fancy: "",
                                          label: `${r}. ${col.label}`,
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.setField(
                                              `${field.key}.${r - 1}.${
                                                col.key
                                              }`,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            }),
                          ],
                          2
                        ),
                  ]
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }